module.exports = __webpack_public_path__ + "img/product-placeholder-31.34a6aba.png";